<template>
    <div class="pagination">
        <div class="currentPage">
            PAGE {{ current }} OF {{ total }}
        </div>
        <ul class="list">
            <li class="step">
                <button
                    :class="{'isDisabled': current === 1}"
                    class="button prev"
                    @click="$emit('changed', current - 1)"
                >
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" fill="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>
                </button>
            </li>
            <li
                v-for="page in pages"
                :key="page"
                class="step"
            >
                <button
                    :class="{'isActive': current === page}"
                    type="button"
                    class="button"
                    @click="$emit('changed', page)"
                >
                    {{ page }}
                </button>
            </li>
            <li class="step">
                <button
                    :class="{'isDisabled': current === total}"
                    class="button next"
                    @click="$emit('changed', current + 1)"
                >
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" fill="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        total: {
            type: Number,
            required: true,
        },
        current: {
            type: Number,
            required: true,
        },
    },
    data: () => ({
        max: 5,
    }),
    computed: {
        leftPrev() {
            return this.current;
        },
        leftNext() {
            return this.total - this.current;
        },
        start() {
            if (this.leftNext < 1) {
                return this.current - 4;
            }

            if (this.leftNext < 2) {
                return this.current - 3;
            }

            return this.current - 2 > 0 ? this.current - 2 : 1;
        },
        end() {
            if (this.leftPrev < 3) {
                return 5;
            }

            return this.current + 2 < this.total ? this.current + 2 : this.total;
        },
        pages() {
            if (this.total <= this.max) {
                return this.generatePages(1, this.total);
            }

            return this.generatePages(this.start, this.end);
        },
    },
    methods: {
        generatePages(start, end) {
            const pages = [];

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        },
    },
};
</script>

<style lang="postcss" scoped>
.pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.currentPage {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 1.6px;
}
.list {
    list-style: none;
    display: flex;
    border: 1px solid var(--borderColor);
    border-radius: var(--borderRadius);
}
.step {
    border-right: 1px solid var(--borderColor);
    &:last-child {
        border-right: 0;
    }
}
.button {
    user-select: none;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 0;
    color: var(--grey600);
    &:hover {
        background-color: var(--borderColor);
    }
    &.isActive {
        background-color: var(--primary);
        color: #fff;
        pointer-events: none;
    }
    &.isDisabled {
        opacity: 0.4;
        pointer-events: none;
    }
}

.button .icon {
    color: var(--primaryTextColor);
    transition: var(--normalTrans);
    width: 20px;
    height: 20px;
    position: relative;
}
.prev .icon {
    transform: rotate(90deg);
    left: -1px;
}
.next .icon {
    transform: rotate(-90deg);
    left: 1px;
}
</style>
